import React from "react";

const Logo = () => {
  return (
    <img
      className="relative mx-auto max-sm:mt-16"
      src="/retta-logo.svg"
      alt="Retta Logo"
    />
  );
};

export default Logo;
